import {
  FaEnvelopeOpenText,
  FaServer,
  FaRegWindowMaximize,
} from "@onemind-services-llc/react-icons-ng/fa";
import { MdOutlineSwapCalls } from "@onemind-services-llc/react-icons-ng/md";
import HeroBg from "public/marketplace-apps/hero/Hero-section-rabbitmq.png";

export const RabbitMQ_CONSTANTS = {
  HERO: {
    title: "OneMind Services — RabbitMQ (One-Click Application) ",
    desc: "Robust open-source message broker supporting reliable messaging, multiple exchange types, and clustering for high availability.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "RabbitMQ is a lightweight, open-source message broker that implements the Advanced Message Queuing Protocol (AMQP). It enables asynchronous communication between services by decoupling message producers and consumers. RabbitMQ is widely used in microservices, streaming, and real-time processing architectures. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure RabbitMQ instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes RabbitMQ server, default user credentials, and optimized system settings.  ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "guest",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access the management console at:  ",
      command: "http://<YOUR_INSTANCE_IP>:15672 ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/rabbitmq/rabbitmq.conf ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: ["5672 (AMQP) ", "15672 (Management Console)", "25672(Clustering)"],
    },
    note: "Note : Find the configuration file at /etc/rabbitmq/rabbitmq.conf for customized tweaks or backup.  ",
  },
  FEATURES: {
    items: [
      {
        icon: FaEnvelopeOpenText,
        title: "Reliable Messaging",
        text: "Supports durable queues, message acknowledgments, and persistence.",
      },
      {
        icon: MdOutlineSwapCalls,
        title: "Exchange Types",
        text: "Flexible routing through direct, topic, fanout, and headers exchanges.",
      },
      {
        icon: FaServer,
        title: "High Availability",
        text: "Supports mirrored queues across nodes for resilience.",
      },
      {
        icon: FaRegWindowMaximize,
        title: "Management UI",
        text: "Browser-based dashboard for monitoring, managing queues, users, and connections.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or rabbitmqctl for backup/export. ",
      },
      {
        label: "Security Out of the Box",
        text: "Configured firewall rules, TLS support, and user access controls. ",
      },
      {
        label: "Scalable Architecture",
        text: "Horizontal scaling via clustering and federation for multi-region messaging.  ",
      },
    ],
  },
  SUPPORT: {
    docsText: "RabbitMQ Official Docs",
    docsLink: "https://www.rabbitmq.com/docs",
  },
};
